// landing_page
function setLandingPageCookie() {
  var landingPage = window.location.pathname + window.location.search;
  var expires = new Date();
  expires.setTime(expires.getTime() + (14 * 24 * 60 * 60 * 1000));
  document.cookie = "landing_page=" + encodeURIComponent(landingPage) + ";expires=" + expires.toUTCString() + ";path=/";
}
if (!document.cookie.includes('landing_page')) {
  setLandingPageCookie();
}
function getLandingPageCookie() {
  var name = "landing_page=";
  var decodedCookie = document.cookie;
  var ca = decodedCookie.split(';');

  // 遍历所有 Cookie 查找 landing_page
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) === 0) {
          return decodeURIComponent(c.substring(name.length, c.length)); // 返回 Cookie 的值
      }
  }
  return null; // 如果没有找到，则返回 null
}
//landing_page end

//不同货币价格格式转换
function Currency_Price_Format(params) {
  if(Shopify.currency.active == 'EUR'){
    var newparams1 = params.replace(/[^0-9.,\s]/g, "").trim();
    var newparams2 = newparams1.replace(/\s/g, "").replace(/\./g, "");
    var newparams = newparams2.replace(",", ".");
    return newparams
  }else{
    var newparams = params.replace(/[^0-9.]/g, "").trim();
    return newparams
  }
}
  
function getClientIdFromGaCookie() {
    var cookieValue = document.cookie.match(/_ga=([^;]+)/);
    if (cookieValue) {
        var clientId = cookieValue[1].split('.').slice(-2).join('.');
        return clientId.replaceAll(".", "%");
    }
    return "";
}
var clientId = getClientIdFromGaCookie();
window.showCartDrawer=0;
var showCartDrawer_list=0;
var showCartDrawer_list_btn_name='';
var showCartPage=0;
var showCartPage_list=0;
var showCartPage_list_btn_name='';
$(function() {
  if($("#CartPage cart-item").length){
    showCartPage=1;
  }
})
function gtm_showCartDrawer() {
  if(showCartDrawer==1){
    showCartDrawer=0;
    if($("#CartDrawer cart-item").length){
      var discount = 0
      $(".cart-drawer-subtotal__sale-item-amount .discount").map(function(item, index) {
        discount=discount + Number($(this).text());
      });
      var items = [];
      $("#CartDrawer cart-item").map(function(item, index) {
        var obj = {
          item_id: $(this).attr('data-variant-id'),
          item_url: $(this).attr('data-url'),
          item_name: $(this).attr('data-title'),
          price: Currency_Price_Format($(this).attr('data-price')),
          quantity: $(this).attr('data-quantity'),
        }
        items.push(obj);
      });
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "view_popup_cart_list",
        ecommerce: {
          client_id: clientId,
          customer_id: CustomerId,
          quantity: $(".cart-drawer-subtotal__price").attr('data-total-quantity'),
          insurance_checkbox: $('#CartDrawer #shipping_insurance').is(':checked'),
          value: Currency_Price_Format($(".cart-drawer-subtotal__price").text()),
          discount: discount,
          items: items,
        }
      });
    }else{
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "view_popup_cart_list",
        ecommerce: {
          client_id: clientId,
          customer_id: CustomerId,
          quantity: 0,
          insurance_checkbox: false,
          value: 0,
          discount: 0,
        },
      });
    }
  }
  if(showCartDrawer_list==1){
    gtm_CartDrawer_interact_cart_list(showCartDrawer_list_btn_name);
    
    showCartDrawer=0;
    showCartDrawer_list_btn_name='';
  }
  if(showCartPage==1){
    showCartPage=0;
    if($("#CartPage cart-item").length){
        var discount = 0
        $(".cart-subtotal__sale-item-amount .discount").map(function(item, index) {
          discount=discount + Number($(this).text());
        });
        var items = [];
        $("#CartPage cart-item").map(function(item, index) {
          var obj = {
            item_id: $(this).attr('data-variant-id'),
            item_url: $(this).attr('data-url'),
            item_name: $(this).attr('data-title'),
            price: Currency_Price_Format($(this).attr('data-price')),
            quantity: $(this).attr('data-quantity'),
          }
          items.push(obj);
        });
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "view_page_cart_list",
          ecommerce: {
            client_id: clientId,
            customer_id: CustomerId,
            quantity: $(".cart-subtotal__totals-price").attr('data-total-quantity'),
            insurance_checkbox: $('#CartPage #shipping_insurance').is(':checked'),
            value: Currency_Price_Format($(".cart-subtotal__totals-price").text()),
            discount: discount,
            items: items,
          }
        });
      }else{
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "view_page_cart_list",
          ecommerce: {
            client_id: clientId,
            customer_id: CustomerId,
            quantity: 0,
            insurance_checkbox: false,
            value: 0,
            discount: 0,
          }
        });
      }
  }
  if(showCartPage_list==1){
    gtm_CartPage_interact_cart_list(showCartPage_list_btn_name);
    
    showCartPage=0;
    showCartPage_list_btn_name='';
  }
}
function gtm_CartDrawer_interact_cart_list(btn_name) {
  if($("#CartDrawer cart-item").length){
    var discount = 0
    $(".cart-drawer-subtotal__sale-item-amount .discount").map(function(item, index) {
      discount=discount + Number($(this).text());
    });
    window.dataLayer = window.dataLayer || [];
    if(btn_name){
      dataLayer.push({
        event: "interact_cart_list",
        cus_params: {
            from: "popup",
            client_id: clientId,
            insurance_checkbox: $('#CartDrawer #shipping_insurance').is(':checked'),
            value: Currency_Price_Format($(".cart-drawer-subtotal__price").text()),
            discount: discount,
            button_name: btn_name,
            landing_page: btn_name == 'checkout'? getLandingPageCookie():'',
        }
      });
    }
    if(btn_name == 'checkout'){
      dataLayer.push({
        event: "cart_checkout",
        cus_params: {
            from: "popup",
            insurance_checkbox: $('#CartDrawer #shipping_insurance').is(':checked'),
            value: Currency_Price_Format($(".cart-drawer-subtotal__price").text()),
            discount: discount,
        }
      });
    }
  }else{
    window.dataLayer = window.dataLayer || [];
    if(btn_name){
      dataLayer.push({
        event: "interact_cart_list",
        cus_params: {
            from: "popup",
            client_id: clientId,
            insurance_checkbox: false,
            value: 0,
            discount: 0,
            button_name: btn_name,
            landing_page: btn_name == 'checkout'? getLandingPageCookie():'',
        }
      });
    }
    if(btn_name == 'checkout'){
      dataLayer.push({
        event: "cart_checkout",
        cus_params: {
            from: "popup",
            insurance_checkbox: false,
            value: 0,
            discount: 0,
        }
      });
    }
  }
}
function gtm_CartPage_interact_cart_list(btn_name) {
  if($("#CartPage cart-item").length){
    var discount = 0
    $(".cart-subtotal__sale-item-amount .discount").map(function(item, index) {
      discount=discount + Number($(this).text());
    });
    window.dataLayer = window.dataLayer || [];
    if(btn_name){
      dataLayer.push({
        event: "interact_cart_list",
        cus_params: {
            from: "page",
            client_id: clientId,
            customer_id: CustomerId,
            insurance_checkbox: $('#CartPage #shipping_insurance').is(':checked'),
            value: Currency_Price_Format($(".cart-subtotal__totals-price").text()),
            discount: discount,
            button_name: btn_name,
            landing_page: btn_name == 'checkout'? getLandingPageCookie():'',
        }
      });
    }
    if(btn_name == 'checkout'){
      dataLayer.push({
        event: "cart_checkout",
        cus_params: {
            from: "page",
            insurance_checkbox: $('#CartPage #shipping_insurance').is(':checked'),
            value: Currency_Price_Format($(".cart-subtotal__totals-price").text()),
            discount: discount,
        }
      });
    }
  }
}
var total_add_to_cart_button_name = '';
$(function() {
  // 保存原始 fetch 方法
  var originalFetch = window.fetch;
  // 重写 fetch 方法
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : input.url;
    if (url.indexOf('/cart/add') !== -1) {
      return originalFetch.apply(this, arguments).then(response => {
        if (response.ok) {
          response.clone().json().then(data => {
            if(data.handle != 'shipping-insurance'){
              //加入购物车成功后触发事件
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({
                event: "total_add_to_cart",
                cus_params: {
                  button_name: total_add_to_cart_button_name,
                  landing_page: getLandingPageCookie(),
                  sku: data.sku,
                  id: data.product_id,
                  title: data.product_title,
                  url: data.url,
                  price: (data.price / 100).toFixed(2),
                },
              });
              total_add_to_cart_button_name = '';
            }
          });
        }
        return response;
      });
    }
    if(url.indexOf('/search/suggest') !== -1){
      
      return originalFetch.apply(this, arguments).then(response => {
        if (response.ok) {
            
            const urlParams = new URLSearchParams(new URL(response.url).search);
            const paramValue = urlParams.get('q');
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: "search_new",
              cus_params: {
                value: paramValue,
                button_name: 'sidebar',
              },
            });
            dataLayer.push({
              event: "search_results_new",
              cus_params: {
                value: paramValue,
                button_name: 'sidebar',
              },
            });
            dataLayer.push({
              event: "search",
              cus_params: {
                value: paramValue,
                button_name: 'sidebar',
              },
            });
            dataLayer.push({
              event: "view_search_results",
              cus_params: {
                value: paramValue,
                button_name: 'sidebar',
              },
            });
            
        }
        return response;
      });
    }
    return originalFetch.apply(this, arguments);
  };

  $("#CartDrawer").on('click', '.gtm-cart-click', function() {
      if ($(this).attr('gtm-button-name')=='plus' || $(this).attr('gtm-button-name')=='minus' || $(this).attr('gtm-button-name')=='remove') {
        showCartDrawer_list=1;
        showCartDrawer_list_btn_name=$(this).attr('gtm-button-name');
        return ;
      }
      gtm_CartDrawer_interact_cart_list($(this).attr('gtm-button-name'));
  });
  $("#CartPage").on('click', '.gtm-cart-click', function() {
      if ($(this).attr('gtm-button-name')=='plus' || $(this).attr('gtm-button-name')=='minus' || $(this).attr('gtm-button-name')=='remove') {
        showCartPage_list=1;
        showCartPage_list_btn_name=$(this).attr('gtm-button-name');
        return ;
      }
      gtm_CartPage_interact_cart_list($(this).attr('gtm-button-name'));
  });
  $("#CartPage").on('click', 'shopify-accelerated-checkout-cart shop-pay-wallet-button', function() {
    
  });
  
  $(document).on('click', 'cart-drawer-related-products a, cart-drawer-related-products .gtm-quickview-btn', function() {
    var item = {
      location_name: "cart_popup",
      id: $(this).parents('vertical-product-card, horizontal-product-card').attr('data-id'),
      url: $(this).parents('vertical-product-card, horizontal-product-card').attr('data-url'),
      title: $(this).parents('vertical-product-card, horizontal-product-card').attr('data-title'),
      price: Currency_Price_Format($(this).parents('vertical-product-card, horizontal-product-card').attr('data-price')),
      image_id: $(this).parents('vertical-product-card, horizontal-product-card').attr('data-image-id'),
      image_url: $(this).parents('vertical-product-card, horizontal-product-card').attr('data-image-url'),
      position: $(this).parents('.card-carousel__slide').index() + 1,
      button_name: $(this).attr('gtm-button-name'),
    }
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "click_recommended_item",
      cus_params: item,
    });
  });

  $(document).on('click', 'body #Quick-view .ga-btn-name', function() {
    gtm_OpenQuickView("click", $(this).attr('ga-btn-name'))
  });
  $(document).on('click', '#Quick-view .product-variant-picker__list label.pill, #Quick-view .product-variant-picker__shape-swatches label.color-swatch-select-parent', function() {
      gtm_OpenQuickView("click", 'option');
  });
  $(document).on('click', 'body #Quick-view .product-media__image', function() {
    var position = '';
    if ($(window).width() > 768) {
      position = $(this).parents('.quick-view-desktop-media-carousel__carousel-slide').index() + 1;
    } else {
      position = $(this).parents('.product-media-carousel-mobile__slide').index() + 1;
    }
    if($('#Quick-view .product__info').attr('data-id')){
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "quickview",
        cus_params: {
          id: $('#Quick-view .product__info').attr('data-id'),
          url: $('#Quick-view .product__info').attr('data-url'),
          title: $('#Quick-view .product__info').attr('data-title'),
          price: Currency_Price_Format($('#Quick-view .product__info .product-price__current-price').text()),
          display_image_id: $(this).parents('product-modal-button').attr('data-media-id'),
          display_image_url: $(this).attr('src'),
          position: position,
          button_name: "image",
        }
      });
    }
  });

  //顶部公告栏
  if($('.announcement-bar').length){
    $(document).on('click', '.announcement-bar .announcement-bar__link, .announcement-bar .social-list__item-link', function() {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_header_notice",
        cus_params: {
            title: $(this).attr('aria-label'),
            url: $(this).attr('href'),
        }
      });
    });
    $(document).on('click', '.announcement-bar .announcement-bar__carousel-btn', function() {
      var arrowurl="";
      if($(this).parent().find('.is-selected .announcement-bar__link').attr('href') != undefined){
        arrowurl=$(this).parent().find('.is-selected .announcement-bar__link').attr('href');
      }
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_notice_arrow",
        cus_params: {
            title: $(this).parent().find('.is-selected').text(),
            url: arrowurl,
            button_name: $(this).attr('aria-label'),
        }
      });
    });
  }

  //headert头部
  $('header .header__logo, header .icon-list .header__icon').click(function() {
    if($(this).attr('aria-label')){
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_header_menu",
        cus_params: {
            value: $(this).attr('aria-label'),
        }
      });
    }
  });
  $(document).on('click', 'header .header__nav a, header .header__dropdown a, drawer-menu a', function() {
    if($(this).attr('aria-label')){
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_catagory",
        cus_params: {
            value: $(this).attr('aria-label'),
        }
      });
    }
  });

  //返回顶部
  $(document).on('click', 'back-to-top-button button', function() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "click_backtop",
    });
  });

  //底部
  $("footer .gtm-footer-a, footer .gtm-footer-copyright a, footer .social-list__item a").click(function() {
    if($(this).attr('aria-label')){
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
          event: "click_footer_menu",
          cus_params: {
              value: $(this).attr('aria-label'),
          }
      });
    }else{
      if($(this).text().trim()){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: "click_footer_menu",
            cus_params: {
                value: $(this).text().trim(),
            }
        });
      }
    }
  });

  //列表页&&搜索页
  if($('.gtm-collection-search').length){
    $(".gtm-collection-search").on('click', '.gtm-btn', function() {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "interact_item_list",
        cus_params: {
          location_name: $('.gtm-collection-search').attr('gtm-template'),
          title: $('.gtm-collection-search').attr('gtm-name'),
          url: $('.gtm-collection-search').attr('gtm-url'),
          quantity: $('.gtm-collection-search').attr('gtm-count'),
          button_name: $(this).attr('gtm-btn-name'),
        }
      });
    });
    $(".gtm-collection-search").on('click', '#ShopProducts a.gtm-btn', function() {
      var image_url = '';
      if($(this).parents('product-card').find('.carousel__slide.is-selected img').length){
        image_url= $(this).parents('product-card').find('.carousel__slide.is-selected img')[0].src;
      }
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_item_list",
        cus_params: {
          location_name: $('.gtm-collection-search').attr('gtm-template'),
          id: $(this).parents('product-card').attr('data-id'),
          url: $(this).parents('product-card').attr('data-url'),
          title: $(this).parents('product-card').attr('data-title'),
          price: Currency_Price_Format($(this).parents('product-card').attr('data-price')),
          image_id: $(this).parents('product-card').find('.carousel__slide.is-selected').attr('gtm-media-id'),
          image_url: image_url,
          position: $(this).parents('.shop__grid-item').index() + 1,
        }
      });
    });
    var gtm_change_filter_btnname= '';
    $(document).on('click', '.gtm-btn-filter', function() {
      gtm_change_filter_btnname= $(this).attr('gtm-btn-name');
      if($(this).attr('gtm-btn-name')=='close'){
        gtm_change_filter();
      }
    });

    window.gtm_change_filter = function(btnname) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const params = {};
      urlParams.forEach(function(value, key) {
         if(params[key]){
            params[key] = params[key] + ',' + value;
         }else{
            params[key] = value;
         }
      });
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "interact_filter",
        cus_params: {
          location_name: $('.gtm-collection-search').attr('gtm-template'),
          value: decodeURIComponent($.param(params).replaceAll('filter.p.m.custom.','')),
          quantity: $('.gtm-collection-search #ShopProductCount2').text().replaceAll('Results','').replaceAll('Result','').trim(),
          button_name: gtm_change_filter_btnname,
        }
      });
    }
  }

  //搜索页
  if($("body").attr('gtm-template')=='search'){
    $("body").on('click', '#ShopProducts a.gtm-btn', function() {
      var image_url = '';
      if($(this).parents('product-card').find('.carousel__slide.is-selected img').length){
        image_url= $(this).parents('product-card').find('.carousel__slide.is-selected img')[0].src;
      }
      const urlParams = new URLSearchParams(new URL(window.location.href).search);
      const paramValue = urlParams.get('q');
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_search_results",
        cus_params: {
          id: $(this).parents('product-card').attr('data-id'),
          title: $(this).parents('product-card').attr('data-title'),
          price: Currency_Price_Format($(this).parents('product-card').attr('data-price')),
          image_id: $(this).parents('product-card').find('.carousel__slide.is-selected').attr('gtm-media-id'),
          image_url: image_url,
          position: $(this).parents('.shop__grid-item').index() + 1,
          value: paramValue,
        }
      });
    });
  }

  //购物车列表页
  if($("body").attr('gtm-template')=='cart'){
    $(document).on('click', 'cart-page cart-related-products vertical-product-card a, cart-page cart-related-products horizontal-product-card a, cart-page cart-related-products .gtm-quickview-btn', function() {
      var item = {
        location_name: "cart_list",
        id: $(this).parents('vertical-product-card, horizontal-product-card').attr('data-id'),
        url: $(this).parents('vertical-product-card, horizontal-product-card').attr('data-url'),
        title: $(this).parents('vertical-product-card, horizontal-product-card').attr('data-title'),
        price: Currency_Price_Format($(this).parents('vertical-product-card, horizontal-product-card').attr('data-price')),
        image_id: $(this).parents('vertical-product-card, horizontal-product-card').attr('data-image-id'),
        image_url: $(this).parents('vertical-product-card, horizontal-product-card').attr('data-image-url'),
        position: $(this).parents('.slider-grid__slide').index() + 1,
        button_name: $(this).attr('gtm-button-name'),
      }
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_recommended_item",
        cus_params: item,
      });
    });
    $(document).on('click', 'cart-page cart-related-products .card-carousel__carousel-btn--prev, cart-page cart-related-products .card-carousel__carousel-btn--next', function() {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_recommended_arrow",
        cus_params: {
          location_name: "cart_list",
          quantity: $(this).parents('slider-grid').find('.slider-grid__slide').length,
        },
      });
    });
  }

  //搜索页
  if($("body").attr('gtm-template')=='search'){
    const urlParams = new URLSearchParams(new URL(window.location.href).search);
    const paramValue = urlParams.get('q');
    if(paramValue){
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "search_new",
        cus_params: {
          value: paramValue,
        },
      });
      dataLayer.push({
        event: "search_results_new",
        cus_params: {
          value: paramValue,
        },
      });
    }
  }

  //专题页
  if($("body").attr('gtm-template')=='page'){
    $(document).on('click', '.gtm-become-an-affiliate-a', function() {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_become-an-affiliate-a",
        cus_params: {
          button_name: $(this).attr('gtm-data-value'),
        },
      });
    });
  }
});
  
function gtm_OpenQuickView(type, button_name) {
  var image_id = [];
  var image_url = [];
  var position = [];
  if ($(window).width() > 768) {
    $('#Quick-view .quick-view-desktop-media-carousel__carousel-slide.is-selected').map(function(item, index) {
        position.push($(this).index() + 1);
        image_id.push($(this).attr('data-media-id'));
        if($(this).attr('data-media-type')=="video"){
          image_url.push($(this).find('video')[0].currentSrc);
        }else{
          image_url.push($(this).find('img').attr('src'));
        }
    });
  } else {
    $('#Quick-view .product-media-carousel-mobile__slide.is-selected').map(function(item, index) {
        position.push($(this).index() + 1);
        image_id.push($(this).attr('data-media-id'));
        if($(this).attr('data-media-type')=="video"){
          image_url.push($(this).find('video')[0].currentSrc);
        }else{
          image_url.push($(this).find('img').attr('src'));
        }
    });
  }
  var cus_params;
  if(type==''){
    cus_params= {
      id: $('#Quick-view .product__info').attr('data-id'),
      url: $('#Quick-view .product__info').attr('data-url'),
      title: $('#Quick-view .product__info').attr('data-title'),
      price: Currency_Price_Format($('#Quick-view .product__info .product-price__current-price').text()),
      image_id: image_id.join(","),
      image_url: image_url.join(","),
      button_name: 'quickview',
    }
  }
  if(type=='click'){
    cus_params= {
      id: $('#Quick-view .product__info').attr('data-id'),
      url: $('#Quick-view .product__info').attr('data-url'),
      title: $('#Quick-view .product__info').attr('data-title'),
      price: Currency_Price_Format($('#Quick-view .product__info .product-price__current-price').text()),
      image_id: image_id.join(","),
      image_url: image_url.join(","),
      button_name: button_name,
    }
    if(button_name == 'add_to_cart'){
      total_add_to_cart_button_name = 'quickview';
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "quickview_add_to_cart",
        cus_params: {}
      });
    }
    if(button_name == 'buynow'){
      var selected_item = $('quick-view .product-variant-picker__list label.pill.selected, .quick-view .product-variant-picker__shape-swatches label.color-swatch-select-parent.selected');
      var selected_cur = [];
      selected_item.each(function(index) {
        selected_cur.push($(this).attr('data-name'));
      });
      var productVariants = JSON.parse($('quick-view variant-picker script[data-variant-picker-variants]')[0].textContent);
      var matchingVariant = productVariants.find(function(variant) {
        return variant.options.join(' / ') == selected_cur.join(' / ');
      });
      
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "quickview_buynow",
        cus_params: {
          id: $('#Quick-view .product__info').attr('data-id'),
          title: $('#Quick-view .product__info').attr('data-title'),
          price: Currency_Price_Format($('#Quick-view .product__info .product-price__current-price').text()),
          sku: matchingVariant.sku,
        }
      });
    }
  }
  if(type=='change'){
    cus_params= {
      id: $('#Quick-view .product__info').attr('data-id'),
      url: $('#Quick-view .product__info').attr('data-url'),
      title: $('#Quick-view .product__info').attr('data-title'),
      price: Currency_Price_Format($('#Quick-view .product__info .product-price__current-price').text()),
      display_image_id: image_id.join(","),
      display_image_url: image_url.join(","),
      position: position.join(","),
      button_name: "slide_image",
    }
  }
  if(cus_params.id){
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "quickview",
      cus_params: cus_params
    });
  }
}
function gtm_change_Carousel(data){
  if($(data).parents('#Quick-view').length){
    gtm_OpenQuickView("change");
  }
  if($("body").attr('gtm-template')=='product'){
    if($(data).parents('product-media-carousel').length){
      window.gtm_change_Carousel_product(data);
    }
  }
  if($("body").attr('gtm-template')=='index'){
    if($(data).parents(".image-slider[gtm-event='click_collection_cobranded']").length){
      window.gtm_change_Carousel_collection_cobranded_index();
    }
  }
}